import { Input } from '@material-ui/core';
import InputMask from 'react-input-mask';
import { formatChars } from '../../../../../constants/forms/formatCharacters.constant';
import {
  getPlaceHolderBasedMaskConfiguration,
  getDayMonthPartsConfiguration,
} from '../../../../helpers/maskPlaceHolderConfiguration';

const MaskedInput = (props) => {
  const { placeholder } = props;
  const removeBracketRegEx = new RegExp(/[\(\)]/, 'g');
  const mask = getPlaceHolderBasedMaskConfiguration(
    placeholder.replace(removeBracketRegEx, ''),
    '',
  );

  const beforeMaskedValueChange = (newState) => {
    const { value } = newState;
    const { dayPart, monthPart } = getDayMonthPartsConfiguration(mask, value);
    // Conditional mask for the 2nd digit of day based on the first digit
    if (dayPart) {
      if (dayPart.startsWith('3')) formatChars['D'] = '[0-1]';
      // To block 39, 32, etc.
      else if (dayPart.startsWith('0')) formatChars['D'] = '[1-9]';
      // To block 00.
      else formatChars['D'] = '[0-9]'; // To allow 05, 15, 25  etc.
    }
    if (monthPart) {
      if (monthPart.startsWith('1')) formatChars['M'] = '[0-2]';
      // To block 15, 16, etc.
      else formatChars['M'] = '[1-9]';
    }

    return { value, selection: newState.selection };
  };
  return (
    <InputMask
      alwaysShowMask
      mask={mask}
      value={props.value}
      onChange={props.onChange}
      formatChars={formatChars}
      beforeMaskedValueChange={beforeMaskedValueChange}
      placeholder={props.placeholder}
      name={props.name}
      className={`field__input ${props.classes.dateOfBirthField} ${
        props.form?.errors?.[props.name]
          ? props.classes['field__input--error']
          : props.classes.dataOfBirthFieldBorder
      }`}
      data-cy="field__input"
      data-testid="dateOfBirth"
      maskChar=""
    >
      {(inputProps) => (
        <Input
          disableUnderline
          inputRef={(input) => {
            props.autoFocusRef && (props.autoFocusRef.current = input);
          }}
          fullWidth
          {...inputProps}
        />
      )}
    </InputMask>
  );
};

export default MaskedInput;
